<script>
import Loader from "@/components/widgets/loader.vue";
import { notify } from '@/helpers/notify' 

export default {
    name: 'ClientList',
    props:[
      "apartmanetId",
      "apartmentName"
    ],
    components: {
        Loader
    },
    data() {
        return {
            form: {},
            submitted: false,
            loading: true,
            rows: [],
            totalRecords: 0,
            serverParams: {
                columnFilters: {},
                sort: [
                    {
                    field: '',
                    type: '',
                    },
                ],
                page: 1,
                perPage: 50,
            },
            currentPage: 0,
            selected: 0, 
            pageLength: 0,
            name:'',
            url: "/apartman/customers-under-apt",
            paginationOptions: {
                enabled: true,
                dropdownAllowAll: false,
                perPage: 50,
                setCurrentPage: 1,
                perPageDropdown: [50, 100, 200],
                nextLabel: 'Sonraki',
                prevLabel: 'Önceki',
                rowsPerPageLabel: 'Kayıt Göster',
                ofLabel: 'of',
                pageLabel: 'sayfa', // for 'pages' mode
                infoFn: params => `Bulunduğun Sayfa ${params.currentPage}`,
            },
            selectOptions: {
                enabled: false,
                selectOnCheckboxOnly: false,
                selectionInfoClass: 'custom-class',
                selectionText: 'adet kayıt seçildi',
                clearSelectionText: 'seçimi iptal et',
                disableSelectInfo: false,
                selectAllByGroup: false,
            },
            columns: [
                {
                    label: 'İsim Soyisim',
                    field: 'fullname',
                    sortable:false
                },
                {
                    label: 'Kullanıcı Adı',
                    field: 'username',
                    sortable:false
                },
                {
                    label: 'Telefon',
                    field: 'phonenumber',
                    sortable:false
                }, 
                {
                    label: 'Whatsapp',
                    field: 'phonenumber2',
                    sortable:false
                },
                {
                    field: '#',
                    sortable: false,
                    thClass: 'width-50',
                },
            ],
        };
    },
    watch:{
        apartmanetId(props){

            if(this.apartmentName){
                this.name = this.apartmentName
            }else{
                this.$http.post('/apartman', { apartmentId: props })
                .then(response =>  this.name = response.data.name )
            }
           
            this.updateParams({columnFilters:{apartmentId:props}})
            this.loadItems()
        },
    },
    methods: {
        updateParams(newProps) {
            this.serverParams = { ...this.serverParams, ...newProps }
        },
        onPageChange(params) {
            this.updateParams({ page: params.currentPage })
            this.loadItems()
        },
        onPerPageChange(params) {
            this.updateParams({ perPage: params.currentPerPage })
            this.loadItems()
        },
        onSortChange(params) {
            this.updateParams({
                sort: params,
            })
            this.loadItems()
        },
        onColumnFilter(params) {
            this.updateParams(params)
            this.loadItems()
        },
        loadItems() {
            this.loading = true
            this.getFromServer(this.serverParams).then(response => {
                this.totalRecords = response.totalRecords
                this.pageLength = response.pageLength
                this.currentPage = response.currentPage
                this.rows = response.rows
                this.loading = false
            })
        },
        getFromServer() {
            return new Promise((resolve, reject) => {
                this.$http.post(this.url, this.serverParams)
                .then(res => {
                    resolve({
                    rows: res.data.data,
                    totalRecords: res.data.total,
                    pageLength: res.data.last_page,
                    currentPage: res.data.current_page,
                    })
                })
                .catch(error => {
                    reject(error)
                })
            })
        },
        selectionChanged(a) {
            this.selected = a.selectedRows.length
        },
        onSearch(params) {
            if(params.searchTerm.length < 4) return
            this.updateParams(params)
            this.loadItems()
        },
        close(){
            this.$parent.$bvModal.hide('client-list-scoped')
        },
        sil({ id }){
            this.$http.post('/apartman/customerSet', {id})
            notify.success('Başarılı')
            this.loadItems()
            this.$emit('loadItems');
        }   
    },
};
</script>  

<template>
    <b-modal id="client-list-scoped" size="xl" :title="`${name} > Apartman Sistemindeki Müşterileri`"  no-close-on-backdrop hide-footer>
        <Loader :loading="true" :load="loading">
        <vue-good-table
            mode="remote"
            :total-rows="totalRecords"
            :columns="columns"
            :rows="rows"
            :search-options="{
                enabled: true,
            }"
            @on-search="onSearch"
            :select-options="selectOptions"
            :pagination-options="paginationOptions"
            @on-selected-rows-change="selectionChanged"
            @on-page-change="onPageChange"
            @on-sort-change="onSortChange"
            @on-column-filter="onColumnFilter"
            @on-per-page-change="onPerPageChange">
            <template slot="loadingContent">
                <div>Yükleniyor</div>
            </template>
            <template
                  slot="table-row"
                  slot-scope="props"
                >
                  <span
                    v-if="props.column.field === '#'"
                    class="text-nowrap"
                  >
                     <ul class="list-inline font-size-20 contact-links mb-0">
                        <li class="list-inline-item">
                          <button 
                            type="button" 
                            class="btn btn-danger btn-sm btn-rounded" 
                            @click="sil(props.row)"> Listeden Çıkart
                          </button>
                        </li>
                      </ul>
                  </span>
                </template>
        </vue-good-table>
        </Loader>
    </b-modal>
</template>